import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { vehicleService } from '../services/api';
import { analytics } from '../services/analytics';
import './FleetPage.css';

const FleetPage = () => {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    passengers: 'all',
    category: 'all'
  });

  useEffect(() => {
    analytics.trackPageView('fleet_page');
    loadVehicles();
  }, []);

  const loadVehicles = async () => {
    try {
      setLoading(true);
      const response = await vehicleService.getAll();
      setVehicles(response.data.data || []);
    } catch (error) {
      console.error('Error loading vehicles:', error);
    } finally {
      setLoading(false);
    }
  };

  const getUniqueCategories = () => {
    const categories = vehicles.map(v => v.category);
    return ['all', ...new Set(categories)];
  };

  const getUniquePassengerCounts = () => {
    const counts = vehicles.map(v => v.features?.passengers).filter(Boolean);
    return ['all', ...new Set(counts)].sort();
  };

  const filteredVehicles = vehicles.filter(vehicle => {
    if (filters.passengers !== 'all' && vehicle.features?.passengers !== parseInt(filters.passengers)) {
      return false;
    }
    if (filters.category !== 'all' && vehicle.category !== filters.category) {
      return false;
    }
    return true;
  });

  const handleReserve = (vehicle) => {
    analytics.trackVehicleConsult(vehicle);
    navigate('/buscar');
  };

  if (loading) {
    return (
      <div className="fleet-page">
        <div className="fleet-container">
          <div className="loading">Cargando flota...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="fleet-page">
      <div className="fleet-container">
        <div className="fleet-header">
          <h1>Nuestra Flota</h1>
          <p className="fleet-subtitle">Encuentra el vehículo perfecto para tu viaje</p>
        </div>

        <div className="fleet-filters">
          <div className="filter-group">
            <label>
              <span className="filter-icon">👥</span>
              <select 
                value={filters.passengers}
                onChange={(e) => setFilters({ ...filters, passengers: e.target.value })}
              >
                <option value="all">Pasajeros</option>
                {getUniquePassengerCounts().filter(c => c !== 'all').map(count => (
                  <option key={count} value={count}>{count} pasajeros</option>
                ))}
              </select>
            </label>
          </div>

          <div className="filter-group">
            <label>
              <span className="filter-icon">🚗</span>
              <select 
                value={filters.category}
                onChange={(e) => setFilters({ ...filters, category: e.target.value })}
              >
                <option value="all">Categorías</option>
                {getUniqueCategories().filter(c => c !== 'all').map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="fleet-grid">
          {filteredVehicles.map(vehicle => (
            <div key={vehicle.id} className="fleet-card">
              <div className="fleet-card-image">
                <img src={vehicle.image || '/placeholder-car.svg'} alt={vehicle.name} />
              </div>
              
              <div className="fleet-card-content">
                <h3 className="fleet-card-title">{vehicle.name}</h3>
                <p className="fleet-card-category">{vehicle.category}</p>
                
                <div className="fleet-card-features">
                  {vehicle.features?.passengers && (
                    <span className="feature-item">
                      <span className="feature-icon">👥</span>
                      {vehicle.features.passengers}
                    </span>
                  )}
                  {vehicle.features?.doors && (
                    <span className="feature-item">
                      <span className="feature-icon">🚪</span>
                      {vehicle.features.doors}
                    </span>
                  )}
                  {vehicle.features?.luggage && (
                    <span className="feature-item">
                      <span className="feature-icon">🧳</span>
                      {vehicle.features.luggage}
                    </span>
                  )}
                  {vehicle.features?.transmission && (
                    <span className="feature-item">
                      <span className="feature-icon">⚙️</span>
                      {vehicle.features.transmission}
                    </span>
                  )}
                </div>

                <button 
                  className="fleet-card-button"
                  onClick={() => handleReserve(vehicle)}
                >
                  RESERVAR AHORA
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredVehicles.length === 0 && (
          <div className="fleet-empty">
            <p>No se encontraron vehículos con los filtros seleccionados.</p>
            <button 
              className="btn-reset"
              onClick={() => setFilters({ passengers: 'all', category: 'all' })}
            >
              Limpiar filtros
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FleetPage;
